import React, { useState, useEffect } from "react";
import {
  AdminContentContainer,
  AdminContentTitle,
  CancelDateForm,
  CancelDateLabel,
  CancelDateInput,
  SubmitButton,
  CheckboxGroup,
  CheckboxLabel,
  Select,
  DateList,
  DateItem,
  DeleteButton,
} from "../styles";
import {
  adminGetSpecialDates,
  adminCreateSpecialDate,
  adminDeleteSpecialDate,
  adminGetBookingConfig,
  adminUpdateBookingConfig,
} from "../api";
import { Spinner } from '.';

const PriceAdjustment = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [newPrice, setNewPrice] = useState("");
  const [bookingType, setBookingType] = useState("");
  const [createdDates, setCreatedDates] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");
  const [bookingConfig, setBookingConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {

        const responseSpecialDates = await adminGetSpecialDates();

        const dataSpecialDates = await responseSpecialDates.json();

        setCreatedDates(dataSpecialDates.specialDates);

        const responseConfig = await adminGetBookingConfig();

        const dataConfig = await responseConfig.json();

        setBookingConfig(dataConfig);

      } catch (error) {
        console.error("Erro ao buscar as datas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    setSelectedDate("");
    setStartTime("");
    setEndTime("");
    setNewPrice("");
    setStatusMessage("");
    setBookingType("");
  };

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleSubmit = async () => {
    const payload = {
      date: selectedDate,
      startTime,
      endTime,
      price: newPrice,
      bookingType: bookingType === "fixed" ? "fixed" : "unique",
    };

    try {
      const response = await adminCreateSpecialDate(payload);

      const result = await response.json();

      if (result.success) {
        setStatusMessage(result.message || "Preço ajustado com sucesso!");
        setSelectedDate("");
        setStartTime("");
        setEndTime("");
        setNewPrice("");
        setBookingType("");

      } else {
        setStatusMessage(result.message || "Erro ao atualizar o preço.");
      }

    } catch (error) {
      console.error("Erro ao enviar os dados:", error);
      setStatusMessage("Erro ao atualizar o preço.");
    } finally {
      refreshCreatedDates();
    }
  };

  const handleDeleteDate = async (id) => {
    try {
      const response = await adminDeleteSpecialDate(id);

      const result = await response.json();

      if (result.success) {
        setStatusMessage(result.message || "Data excluída com sucesso.");
      } else {
        setStatusMessage(result.message || "Erro ao excluir a data.");
      }

    } catch (error) {
      console.error("Erro ao excluir a data:", error);
      setStatusMessage("Erro ao excluir a data.");
    } finally {
      refreshCreatedDates();
    }
  };

  const refreshCreatedDates = async () => {
    try {
      setLoading(true);

      const response = await adminGetSpecialDates();

      const data = await response.json();

      setCreatedDates(data.specialDates);

    } catch (error) {
      console.error("Erro ao buscar configuração de reservas:", error);
    } finally {
      setLoading(false);
    }
  };

  const refreshBookingConfig = async () => {
    try {
      setLoading(true);

      const response = await adminGetBookingConfig();

      const data = await response.json();

      setBookingConfig(data);

    } catch (error) {
      console.error("Erro ao buscar configuração de reservas:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveBookingConfig = async () => {
    try {
      const payload = {
        hourValueUniqueDay: parseFloat(bookingConfig.dayBookingUniqueValue),
        hourValueFixedDay: parseFloat(bookingConfig.dayBookingFixedValue),
        hourValueUniqueNight: parseFloat(bookingConfig.nightBookingUniqueValue),
        hourValueFixedNight: parseFloat(bookingConfig.nightBookingFixedValue),
        hourValueUniqueWeekend: parseFloat(bookingConfig.weekendBookingUniqueValue),
        hourValueFixedWeekend: parseFloat(bookingConfig.weekendBookingFixedValue),
        initTimeWeekend: bookingConfig.initWeekend,
        finishTimeWeekend: bookingConfig.finishWeekend,
        initTimeRegular: bookingConfig.initRegular,
        finishTimeRegular: bookingConfig.finishRegular,
      };
      
      const response = await adminUpdateBookingConfig(payload);

      const result = await response.json();

      if (result.success) {
        setStatusMessage(result.message || "Configuração de reservas atualizada com sucesso!");
      } else {
        setStatusMessage(result.message || "Erro ao atualizar configuração de reservas.");
      }

    } catch (error) {
      console.error("Erro ao salvar configuração de reservas:", error);
      setStatusMessage("Erro ao salvar configuração.");
    } finally {
      refreshBookingConfig();
    }
  };

  return (
    <AdminContentContainer>
      <AdminContentTitle>Alteração de Preço</AdminContentTitle>

      <CheckboxGroup>
        <CheckboxLabel>
          <CancelDateInput
            type="radio"
            name="adjustmentType"
            checked={selectedOption === "specific"}
            onChange={() => handleOptionChange("specific")}
          />
          Alterar preço de uma data específica
        </CheckboxLabel>
      </CheckboxGroup>

      <CheckboxGroup>
        <CheckboxLabel>
          <input
            type="radio"
            checked={selectedOption === "updateConfig"}
            onChange={() => handleOptionChange("updateConfig")}
          />
          Alterar configuração geral de reservas
        </CheckboxLabel>
      </CheckboxGroup>

      {selectedOption === "updateConfig" && bookingConfig && (
        <div style={{display: "flex", flexDirection: "column"}}>
          <CancelDateLabel>Reserva Avulsa - Período Diurno</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="number"
            value={bookingConfig.dayBookingUniqueValue}
            onChange={(e) => setBookingConfig({ ...bookingConfig, dayBookingUniqueValue: e.target.value })}
          />

          <CancelDateLabel>Reserva Avulsa - Período Noturno</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="number"
            value={bookingConfig.nightBookingUniqueValue}
            onChange={(e) => setBookingConfig({ ...bookingConfig, nightBookingUniqueValue: e.target.value })}
          />

          <CancelDateLabel>Reserva Avulsa - Finais de Semana</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="number"
            value={bookingConfig.weekendBookingUniqueValue}
            onChange={(e) => setBookingConfig({ ...bookingConfig, weekendBookingUniqueValue: e.target.value })}
          />

          <CancelDateLabel>Reserva Mensal - Período Diurno</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="number"
            value={bookingConfig.dayBookingFixedValue}
            onChange={(e) => setBookingConfig({ ...bookingConfig, dayBookingFixedValue: e.target.value })}
          />

          <CancelDateLabel>Reserva Mensal - Período Noturno</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="number"
            value={bookingConfig.nightBookingFixedValue}
            onChange={(e) => setBookingConfig({ ...bookingConfig, nightBookingFixedValue: e.target.value })}
          />

          <CancelDateLabel>Reserva Mensal - Finais de Semana</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="number"
            value={bookingConfig.weekendBookingFixedValue}
            onChange={(e) => setBookingConfig({ ...bookingConfig, weekendBookingFixedValue: e.target.value })}
          />

          <CancelDateLabel>Horário Inicial - Dias Úteis</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="time"
            value={bookingConfig.initRegular}
            onChange={(e) => setBookingConfig({ ...bookingConfig, initRegular: e.target.value })}
          />

          <CancelDateLabel>Horário Inicial - Finais de Semana</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="time"
            value={bookingConfig.initWeekend}
            onChange={(e) => setBookingConfig({ ...bookingConfig, initWeekend: e.target.value })}
          />

          <CancelDateLabel>Horário Final - Dias Úteis</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="time"
            value={bookingConfig.finishRegular}
            onChange={(e) => setBookingConfig({ ...bookingConfig, finishRegular: e.target.value })}
          />

          <CancelDateLabel>Horário Final - Finais de Semana</CancelDateLabel>
          <CancelDateInput
            style={{marginBottom: "10px"}}
            type="time"
            value={bookingConfig.finishWeekend}
            onChange={(e) => setBookingConfig({ ...bookingConfig, finishWeekend: e.target.value })}
          />

          <SubmitButton onClick={handleSaveBookingConfig}>Salvar Configuração</SubmitButton>
        </div>
      )}

      {selectedOption === "specific" && (
        <CancelDateForm>
          <CancelDateLabel>
            Selecione a Data:
            <CancelDateInput type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
          </CancelDateLabel>
          <CancelDateLabel>
            Horário Inicial:
            <CancelDateInput
              type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </CancelDateLabel>
          <CancelDateLabel>
            Horário Final:
            <CancelDateInput
              type="time"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </CancelDateLabel>
          <CancelDateLabel>
            Novo Preço:
            <CancelDateInput
              type="number"
              placeholder="Ex: 150"
              value={newPrice}
              onChange={(e) => setNewPrice(e.target.value)}
            />
          </CancelDateLabel>
          <CancelDateLabel>
            Tipo de Reserva:
            <Select
              value={bookingType}
              onChange={(e) => setBookingType(e.target.value)}
            >
              <option value="fixed">Mensal</option>
              <option value="unique">Avulsa</option>
            </Select>
          </CancelDateLabel>
          <SubmitButton onClick={handleSubmit}>Criar Ajuste de Preço</SubmitButton>
        </CancelDateForm>
      )}

      {statusMessage && <p style={{ color: statusMessage.includes("sucesso") ? "green" : "red" }}>{statusMessage}</p>}

      <AdminContentTitle style={{ marginTop: "40px" }}>Datas específicas com novos preços:</AdminContentTitle>

      {loading ? <Spinner /> : createdDates && createdDates.length > 0 ? (
        <DateList>
          {createdDates.map((dateItem) => (
            <DateItem key={dateItem.id}>
              <strong>Data:</strong> {formatDate(dateItem.date)}
              <strong>Preço:</strong> R$ {dateItem.price}
              <strong>Horário:</strong> {dateItem.startTime} - {dateItem.endTime}
              <strong>Tipo de Reserva:</strong> {dateItem.bookingType === "unique" ? "Avulsa" : "Mensal"}
              <DeleteButton onClick={() => handleDeleteDate(dateItem.id)}>Excluir</DeleteButton>
            </DateItem>
          ))}
        </DateList>
      ) : (
        <p>Nenhuma data criada.</p>
      )}
    </AdminContentContainer>
  );
};

export default PriceAdjustment;
